module.exports = __webpack_public_path__ + "static/food2-6a3d458b2586dfdc112184d54769f42d.jpg";